/**
 * Returns 'front' or 'back' based on a rotateY(angle) value.
 * Front is visible when the coin shows degrees in [-90, 90] (mod 360).
 */
export const sideFromAngle = (angle) => {
  // Normalize to [0, 360)
  const a = ((angle % 360) + 360) % 360;
  return a > 90 && a < 270 ? 'back' : 'front';
};
